export function hasFeature(user, featureName) {
    var _a, _b;
    return (user === null || user === void 0 ? void 0 : user.hasActiveSubscription) && ((_b = (_a = user === null || user === void 0 ? void 0 : user.firm) === null || _a === void 0 ? void 0 : _a.subscription) === null || _b === void 0 ? void 0 : _b.features.some(feature => feature.name === featureName));
}
export function getFeatureLimit(user, featureName) {
    if (!user.firm) {
        return 0;
    }
    const feature = user.firm.subscription.features.find(feature => (feature === null || feature === void 0 ? void 0 : feature.name) === featureName);
    return (feature === null || feature === void 0 ? void 0 : feature.value) || 0;
}
export function isBillingAdmin(user) {
    if (!user.firm) {
        return false;
    }
    return user.firm.billingUser.id === user.id;
}
